module.exports = __webpack_public_path__ + "assets/img/alerm.f3826a49.png";